import { s3FontList } from './common/utils/loadFont';

export const Test = () => {
  return (
    <div>
      {s3FontList.map((font) => {
        const fontFamily = `${font.name} Regular`;
        return (
          <div
            style={{
              fontFamily,
              fontSize: '30px'
            }}
            key={font.name}
          >
            {fontFamily}
          </div>
        );
      })}
    </div>
  );
};
